export type PaymentTypeMessages = {
  cardTitle: string;

  // Empty state
  noPaymentTypeMessage: string;
  noPaymentTypeDescription: string;
  addPaymentTypeButtonLabel: string;

  // Table columns
  paymentTypeColumn: string;
  activeColumn: string;
  discountAppliedColumn: string;
  discountOverColumn: string;
  optionsColumn: string;

  // Table
  newPaymentTypeButtonLabel: string;
  rowsPerPage: string;
  emptyTableMessage: string;
  activeYes: string;
  activeNo: string;

  // Form
  formTitleCreate: string;
  formTitleEdit: string;
  paymentTypeLabel: string;
  activeLabel: string;
  discountAppliedLabel: string;
  discountOverLabel: string;
  maxInstallmentCountLabel: string;
  minInstallmentAmountLabel: string;
  interestRatesSectionLabel: string;
  interestRateLabel: string;
  cancelButton: string;
  saveButton: string;

  // Validation
  paymentTypeRequired: string;
  discountAppliedRequired: string;
  discountOverRequired: string;
  maxInstallmentCountRequired: string;
  maxInstallmentCountMin: string;
  minInstallmentAmountRequired: string;
  interestRatesRequired: string;
  positiveNumber: string;

  // Loading / errors
  loadingText: string;
  noOptionsText: string;
  errorTitle: string;
  errorDescription: string;
  errorAlt: string;

  // Popover
  editPopover: string;
  removePopover: string;

  // Confirmation
  deleteDialogTitle: string;
  deleteDialogContent: string;
  deleteDialogCancel: string;
  deleteDialogConfirm: string;

  // Toasts
  createSuccess: string;
  createError: string;
  updateSuccess: string;
  updateError: string;
  deleteSuccess: string;
  deleteError: string;
};

export const PAYMENT_TYPE_MESSAGES: PaymentTypeMessages = {
  cardTitle: "Formas de Pagamento",

  noPaymentTypeMessage: "Você ainda não cadastrou nenhuma forma de pagamento.",
  noPaymentTypeDescription:
    "Dessa forma suas vendas sempre acontecerão com o método de pagamento \"link de pagamento\".",
  addPaymentTypeButtonLabel: "Adicionar forma de pagamento",

  paymentTypeColumn: "Forma de Pagamento",
  activeColumn: "Ativo",
  discountAppliedColumn: "Desconto automático",
  discountOverColumn: "Desconto automático para compras acima de",
  optionsColumn: "Opções",

  newPaymentTypeButtonLabel: "Adicionar forma de pagamento",
  rowsPerPage: "Linhas por página",
  emptyTableMessage: "Nenhuma forma de pagamento encontrada.",
  activeYes: "Sim",
  activeNo: "Não",

  formTitleCreate: "Cadastrar forma de pagamento",
  formTitleEdit: "Editar forma de pagamento",
  paymentTypeLabel: "Forma de pagamento",
  activeLabel: "Ativo",
  discountAppliedLabel: "Desconto automático (%)",
  discountOverLabel: "Desconto automático para compras acima de",
  maxInstallmentCountLabel: "Máximo de parcelas",
  minInstallmentAmountLabel: "Valor mínimo da parcela",
  interestRatesSectionLabel: "Taxas de juros mensais por parcela",
  interestRateLabel: "{count}x — taxa (% a.m.)",
  cancelButton: "Cancelar",
  saveButton: "Salvar",

  paymentTypeRequired: "Selecione uma forma de pagamento.",
  discountAppliedRequired: "O desconto automático é obrigatório.",
  discountOverRequired: "O valor é obrigatório.",
  maxInstallmentCountRequired: "Informe o máximo de parcelas.",
  maxInstallmentCountMin: "O máximo de parcelas deve ser no mínimo 1.",
  minInstallmentAmountRequired: "Informe o valor mínimo da parcela.",
  interestRatesRequired: "Informe a taxa de juros para cada parcela.",
  positiveNumber: "O valor deve ser maior ou igual a zero.",

  loadingText: "Carregando",
  noOptionsText: "Nenhuma forma de pagamento disponível",
  errorTitle: "Erro ao carregar",
  errorDescription: "Não foi possível carregar as formas de pagamento.",
  errorAlt: "Erro",

  editPopover: "Editar",
  removePopover: "Remover",

  deleteDialogTitle: "Remover forma de pagamento",
  deleteDialogContent:
    "Você tem certeza de que deseja remover esta forma de pagamento? Esta ação não pode ser desfeita.",
  deleteDialogCancel: "Cancelar",
  deleteDialogConfirm: "Confirmar",

  createSuccess: "Forma de pagamento cadastrada com sucesso.",
  createError: "Erro ao cadastrar forma de pagamento.",
  updateSuccess: "Forma de pagamento atualizada com sucesso.",
  updateError: "Erro ao atualizar forma de pagamento.",
  deleteSuccess: "Forma de pagamento removida com sucesso.",
  deleteError: "Erro ao remover forma de pagamento.",
};
